import { api } from '@/lib/api/axios';
import { Service } from '@/types';
import { ApiCompany, ApiCompanyBySlug, ApiCompanyProfessionals } from '@/types/api';
import { FavoriteCompaniesCountDto, FavoriteCompanyDto } from '@/types/dto/company-favorite.dto';
import type { CompanyReviewsResponseDto } from '@/types/dto/company-review.dto';
import { ListCompaniesParams } from '@/types/dto/ListCompaniesParams.dto';
import { ListResponseDto } from '@/types/ListResponse.dto';

export const CompanyService = {
  list: async (params: ListCompaniesParams): Promise<ListResponseDto<ApiCompany[]>> => {
    const { data } = await api.get<ListResponseDto<ApiCompany[]>>('/company', {
      params,
    });

    return data;
  },
  getBySlug: async (slug: string): Promise<ApiCompanyBySlug> => {
    const { data } = await api.get<ApiCompanyBySlug>(`/company/slug/${slug}`);

    return data;
  },
  getServices: async (companyId: string): Promise<ListResponseDto<Service[]>> => {
    const { data } = await api.get<ListResponseDto<Service[]>>(`/company/${companyId}/services`);

    return data;
  },
  getProfessionals: async (
    companyId: string,
  ): Promise<ApiCompanyProfessionals[] | ListResponseDto<ApiCompanyProfessionals[]>> => {
    const { data } = await api.get<ApiCompanyProfessionals[] | ListResponseDto<ApiCompanyProfessionals[]>>(
      `/company/${companyId}/professionals`,
    );

    return data;
  },
  getReviews: async (companyId: string, skip = 0, take = 6): Promise<CompanyReviewsResponseDto> => {
    const { data } = await api.get<CompanyReviewsResponseDto>(`/company/${companyId}/reviews`, {
      params: { skip, take },
    });

    return data;
  },
  listFavorites: async (): Promise<FavoriteCompanyDto[]> => {
    const { data } = await api.get<FavoriteCompanyDto[]>('/company/favorites');

    return data;
  },
  addFavorite: async (companyId: string): Promise<void> => {
    await api.post(`/company/${companyId}/favorite`);
  },
  removeFavorite: async (companyId: string): Promise<void> => {
    await api.delete(`/company/${companyId}/favorite`);
  },
  getFavoritesCount: async (): Promise<FavoriteCompaniesCountDto> => {
    const { data } = await api.get<FavoriteCompaniesCountDto>('/company/favorites/count');

    return data;
  },
};
